import { render, staticRenderFns } from "./TenderPreview.vue?vue&type=template&id=0c4f3608&scoped=true&"
import script from "./TenderPreview.vue?vue&type=script&lang=js&"
export * from "./TenderPreview.vue?vue&type=script&lang=js&"
import style0 from "./TenderPreview.vue?vue&type=style&index=0&id=0c4f3608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4f3608",
  null
  
)

export default component.exports